<template>
  <!--  交通与住宿-->
  <div
    style="
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
	  padding-top: 60px;
    "
  >
    <Breadcrumb
      :value="[$t('h.tabName1'), $t('h.tabName2'), $t('h.tabName2Item5')]"
    />
    <div style="width: 1200px; height: auto">
      <div style="display: flex; padding: 30px 20px">
        <a-button-group>
          <a-button
            @click="tabChange(index)"
            v-for="(item, index) in tabData"
            :key="index"
            :style="
              item.select
                ? 'color: #FFFFFF;background: #d7000F;border: none;'
                : 'color: #666666;background: transparent;border: 1px solid #DDDDDD;'
            "
            style="
              width: 288px;
              height: 48px;
              font-family: SourceHanSansCN-Medium;
              font-size: 20px;
            "
          >
            {{ item.label }}
          </a-button>
        </a-button-group>
      </div>
      <!--交通-->
      <div v-if="tabIndex === 0" style="padding: 0 20px 100px 20px">
        <div
          style="
            font-family: SourceHanSansCN-Medium;
            font-size: 30px;
            color: #d7000F;
            padding-top: 30px;
          "
        >
          {{ trafficTitle }}
          <!--          {{ $t('h.tran.title') }}-->
        </div>
        <div v-html="trafficSubTitle" class="rich-content" style="padding-top: 30px"></div>
        <!--        <div-->
        <!--            style="font-family: SourceHanSansCN-Medium;font-size: 14px;color: #444444;line-height: 35px;text-indent: 2em;padding-top: 30px;padding-right: 30px;">-->
        <!--          {{ $t('h.tran.content') }}-->
        <!--        </div>-->
        <!--        <div-->
        <!--            style="font-family: SourceHanSansCN-Medium;font-size: 14px;color: #131313;line-height: 35px;">-->
        <!--          {{ $t('h.tran.addressLabel') }}<a href="">{{ $t('h.tran.addressValue') }}</a>-->
        <!--        </div>-->
        <div
          style="
            padding-bottom: 20px;
            font-family: SourceHanSansCN-Medium;
            font-size: 20px;
            color: #131313;
            line-height: 35px;
            margin-top: 12px;
          "
        >
          {{ $t("h.tran.title2") }}
        </div>
        <div
          v-for="(item, index) in trafficData"
          :key="index"
          style="
            width: 100%;
            height: auto;
            background: #ffffff;
            border: 1px solid #d8d8d8;
            border-radius: 1px;
            margin-top: 20px;
            padding: 12px 24px;
          "
        >
          <div style="display: flex; align-items: center; height: 35px">
            <div style="padding: 0 12px">
              <img :src="item.icon" style="width: 28px; height: auto" />
            </div>
            <div
              @click="itemClick(index)"
              class="flex align-center justify-between"
              style="width: 100%"
            >
              <div
                class="typeTitle"
                :style="item.more ? 'color: #D7000F;' : ''"
              >
                {{ $language == "ZH" ? item.title : item.titleEn }}
              </div>
              <img
                class="customBtn"
                src="@/assets/img/zhankaishouqi.png"
                :style="item.more ? 'transform: rotate(180deg)' : ''"
                style="width: 24px; height: 24px"
              />
            </div>
          </div>
          <div v-show="item.more" style="padding-top: 12px">
            <div v-if="$language === 'ZH'" v-html="item.content" class="rich-content"></div>
            <div v-else v-html="item.contentEn" class="rich-content"></div>
          </div>
        </div>
        <!--        <div v-for="(item,index) in listData" :key="index"-->
        <!--             style="width: 100%;height: auto;background: #FFFFFF;border: 1px solid #D8D8D8;border-radius: 1px;margin-top: 20px;padding: 12px 24px;">-->
        <!--          <div style="display: flex;align-items: center;height: 35px;">-->
        <!--            <div style="padding: 0 12px;">-->
        <!--              <img :src="item.image" style="width: 28px;height: auto;"/>-->
        <!--            </div>-->
        <!--            <div @click="itemClick(index)" class="flex align-center justify-between" style="width: 100%;">-->
        <!--              <div class="typeTitle" :style="item.more ? 'color: #D7000F;':''">-->
        <!--                {{ item.title }}-->
        <!--              </div>-->
        <!--              <img class="customBtn" src="@/assets/img/zhankaishouqi.png" :style="item.more ? 'transform: rotate(180deg)':''" style="width: 24px;height: 24px;"/>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div v-show="item.more" style="padding-top: 12px;">-->
        <!--            <div v-for="(childItem,childIndex) in item.children" :key="childIndex"-->
        <!--                 style="font-family: SourceHanSansCN-Normal;font-size: 14px;color: #131313;line-height: 28px;">-->
        <!--              {{ childItem.label }}-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <!--住宿-->
      <div v-else style="padding-bottom: 100px">
        <div
          style="
            width: 1200px;
            height: 330px;
            margin-bottom: 40px;
            overflow: hidden;
          "
        >
          <img :src="hotelImage" class="customImage" />
        </div>
        <div style="padding: 20px 0; line-height: 1.8; font-size: 14px; color: #333;">
          <template v-if="$language === 'ZH'">
            <p>为了方便您参观展会，主办方为您精选了场馆附近的酒店，价格优惠预订从速！</p>
            <p style="margin-top: 10px;">如需了解更多酒店信息，请访问<a href="https://www.sniec.net/cn/visit_accommodation.php?#breadcrumbs" target="_blank" style="color: #d7000F;">这里</a></p>
          </template>
          <template v-else>
            <p>To facilitate your trip, we selected the hotels near the venue for you at a discount price!</p>
            <p style="margin-top: 10px;">Please download the recommend hotel list <a href="https://www.wirechina.net/file/mds/en/21 Form D2 Accommodation.pdf" target="_blank" style="color: #d7000F;">here</a>.</p>
            <p style="margin-top: 10px;">For more information about accommodation near the venue, please click <a href="https://www.mxydt.com/exhibition/56406?lang=en" target="_blank" style="color: #d7000F;">here</a>.</p>
          </template>
        </div>
         <!-- 供应商展示区域 - 左右分栏 -->
         <div
           style="
             display: flex;
             justify-content: space-between;
             width: 100%;
             margin-top: 30px;
			 display: none;
           "
         >
           <!-- 左侧供应商 -->
           <div
             style="
               width: 48%;
               background: #ffffff;
               border-radius: 8px;
               box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
               padding: 30px;
               display: flex;
               flex-direction: column;
             "
           >
             <h3 style="font-size: 22px; margin-bottom: 15px; color: #333">
               {{ $language === "ZH" ? "上海盟轩展览服务有限公司" : "Mengxuan Exhibition" }}
             </h3>
             <div style="margin-bottom: 20px">
               <p style="line-height: 1.8">
                 {{ $language === "ZH" ? "盟轩为客户提供了个性化的会展吃住行服务,为会展业提供全方位“吃住行”综合解决方案。" : "We offer premium hotels, group rates, shuttle services, VIP customization, and business travel insurance, providing comprehensive solutions for Catering, Accommodation, and Travel." }}
               </p>
             </div>
             <div style="margin-top: auto; display: flex; justify-content: center">
               <div style="text-align: center">
<!--                               <img
                                 src="@/assets/img/qrcode-mengxuan.png"
                                 alt="扫码联系"
                                 style="width: 150px; height: 150px; margin-bottom: 10px"
                               /> -->
      	<img :src="langImages[$i18n.locale] || langImages.zh" alt="扫码联系" style="width: 150px; height: 150px; margin-bottom: 10px">
<!--                 <p style="font-size: 14px; color: #666">
                   {{ $t("custom.ScanQRCode") }}
                 </p> -->
               </div>
             </div>
           </div>
           
           <!-- 右侧供应商 -->
           <div
             style="
               width: 48%;
               background: #ffffff;
               border-radius: 8px;
               box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
               padding: 30px;
               display: flex;
               flex-direction: column;
             "
           >
             <h3 style="font-size: 22px; margin-bottom: 15px; color: #333">
               {{ $language === "ZH" ? "忑艺会展服务（上海）有限公司" : "Art Exhibition Service (Shanghai) Co., Ltd " }}
             </h3>
             <div style="margin-bottom: 20px">
               <p style="line-height: 1.8">
                 {{ $language === "ZH" ? " " : " " }}
               </p>
             </div>
             <div style="margin-top: auto; display: flex; justify-content: center">
               <div style="text-align: center">
                               <img
                                 src="@/assets/img/qrcode-zhiyi.png"
                                 alt="扫码预订"
                                 style="width: 150px; height: 150px; margin-bottom: 10px"
                               />
<!--                 <p style="font-size: 14px; color: #666">
                   {{ $t("custom.ScanQRCode") }}
                 </p> -->
               </div>
             </div>
           </div>
         </div>
         
         <Linkage style="margin-top: 40px" :list="linkageInfo"></Linkage>
       </div>
     </div>
   </div>
 </template>


<script>
import {
  codeConfig,
  trafficOptions,
  hotelTable,
  linkage,
} from "../../../assets/api";
import Linkage from "../../components/Linkage";
import che1 from "@/assets/img/car-sijiache.png";
import che2 from "@/assets/img/car-chuzuche.png";
import che3 from "@/assets/img/car-ditie.png";
import che4 from "@/assets/img/car-huoche.png";
import che5 from "@/assets/img/car-feiji.png";

export default {
  name: "Transportation",
  components: {
    Linkage,
  },
  data() {
    return {
      tabIndex: 0,
      tabData: [
        {
          label: this.$t("h.tran.btn1"),
          select: true,
        },
        {
          label: this.$t("h.tran.btn2"),
          select: false,
        },
      ],
	  langImages: {
	    zh: require('@/assets/img/qrcode-mengxuan.png'),
	    en: require('@/assets/img/qrcode-mengxuan-en.png')
	  },
      listData: [
        {
          image: che1,
          title: this.$t("h.tran.box1.title"),
          more: false,
          children: [
            {
              label: this.$t("h.tran.box1.content1"),
            },
            {
              label: this.$t("h.tran.box1.content2"),
            },
            {
              label: this.$t("h.tran.box1.content3"),
            },
          ],
        },
        {
          image: che2,
          title: this.$t("h.tran.box2.title"),
          more: false,
          children: [
            {
              label: this.$t("h.tran.box2.content1"),
            },
          ],
        },
        {
          image: che3,
          title: this.$t("h.tran.box3.title"),
          more: false,
          children: [
            {
              label: this.$t("h.tran.box3.content1"),
            },
            {
              label: this.$t("h.tran.box3.content2"),
            },
            {
              label: this.$t("h.tran.box3.content3"),
            },
            {
              label: this.$t("h.tran.box3.content4"),
            },
            {
              label: this.$t("h.tran.box3.content5"),
            },
          ],
        },
        {
          image: che4,
          title: this.$t("h.tran.box4.title"),
          more: false,
          children: [
            {
              label: this.$t("h.tran.box4.content1"),
            },
            {
              label: this.$t("h.tran.box4.content2"),
            },
            {
              label: this.$t("h.tran.box4.content3"),
            },
            {
              label: this.$t("h.tran.box4.content4"),
            },
            {
              label: this.$t("h.tran.box4.content5"),
            },
            {
              label: this.$t("h.tran.box4.content6"),
            },
          ],
        },
        {
          image: che5,
          title: this.$t("h.tran.box5.title"),
          more: false,
          children: [
            {
              label: this.$t("h.tran.box5.content1"),
            },
            {
              label: this.$t("h.tran.box5.content2"),
            },
            {
              label: this.$t("h.tran.box5.content3"),
            },
            {
              label: this.$t("h.tran.box5.content4"),
            },
            {
              label: this.$t("h.tran.box5.content5"),
            },
            {
              label: this.$t("h.tran.box5.content6"),
            },
            {
              label: this.$t("h.tran.box5.content7"),
            },
            {
              label: this.$t("h.tran.box5.content8"),
            },
          ],
        },
      ],
      dataSource: [
        {
          key: "1",
          name: "新国际博览中心城际酒店",
          nameEn: "New International Expo Center Intercity Hotel",
          star: 4,
          address: "兰花路 308号盈丰天地A 座五层",
          addressEn: "5 / F, Block A, Yingfeng Tiandi, 308 Orchid Road",
          place: "880 元",
          placeEn: "880 Yuan",
          shuttleTransfer: "无",
          shuttleTransferEn: "No",
          distance: "距展馆400米",
          distanceEn: "400 meters from the exhibition hall",
        },
        {
          key: "2",
          name: "上海南万枫酒店",
          nameEn: "Shanghai Hainan Wanfeng Hotel",
          star: 4,
          address: "浦东新区沪南路938号",
          addressEn: "938 Hu Nan Road, Pudong New Area",
          place: "628 元",
          placeEn: "625 Yuan",
          shuttleTransfer: "免费班车",
          shuttleTransferEn: "Free shuttle",
          distance: "新酒店，距展馆4公里，周边方便",
          distanceEn:
            "New hotel, 4 km away from the exhibition hall, convenient surroundings",
        },
        {
          key: "3",
          name: "陆家嘴丽呈酒店",
          nameEn: "Lujiazui Licheng Hotel",
          star: 4,
          address: "浦东新区南洋泾路568号",
          addressEn: "568 Nanyang Jing Road, Pudong New Area",
          place: "578 元",
          placeEn: "578 Yuan",
          shuttleTransfer: "免费班车",
          shuttleTransferEn: "Free shuttle",
          distance: "距展馆2.5公里,约5分钟车程，交通方便",
          distanceEn:
            "2.5 km away from the exhibition hall, about 5 minutes by car, convenient transportation",
        },
        {
          key: "4",
          name: "皇廷世纪酒店",
          nameEn: "The Imperial Century Hotel",
          star: 5,
          address: "浦东新区唐安路588号",
          addressEn: "588 Tang 'an Road, Pudong New Area",
          place: "578 元",
          placeEn: "578 Yuan",
          shuttleTransfer: "免费班车",
          shuttleTransferEn: "Free shuttle",
          distance: "2号线地铁口，约15-20分钟，周边吃饭方便",
          distanceEn:
            "Line 2 subway exit, about 15-20 minutes, easy to eat around",
        },
        {
          key: "5",
          name: "万信喜来登福朋酒店",
          nameEn: "Four Points by Sheraton Ten Thousand Letters",
          star: 4,
          address: "浦东新区秀沿路1668号",
          addressEn: "1668 Xiuyan Road, Pudong New Area",
          place: "478 元",
          placeEn: "478 Yuan",
          shuttleTransfer: "免费班车",
          shuttleTransferEn: "Free shuttle",
          distance: "距展馆11公里，15-20分钟车程，交通方便",
          distanceEn:
            "11km away from the exhibition hall, 15-20 minutes by car, convenient transportation",
        },
        {
          key: "6",
          name: "维也纳康桥地铁站店",
          nameEn: "Vienna Kangqiao Metro Station",
          star: 4,
          address: "周浦康桥镇秀浦路833号",
          addressEn: "No.833, Xiupu Road, Kangqiao Town, Zhoupu",
          place: "458 元",
          placeEn: "458 Yuan",
          shuttleTransfer: "免费班车",
          shuttleTransferEn: "Free shuttle",
          distance: "18号地铁口，约15-20分钟车程，用餐方便",
          distanceEn:
            "18 subway exit, about 15-20 minutes by car, convenient for dining",
        },
        {
          key: "7",
          name: "宜必思酒店联洋店",
          nameEn: "Ibis Hotel Lianyang Branch",
          star: 4,
          address: "芳甸路200号",
          addressEn: "200 Fangdian Road",
          place: "438 元",
          placeEn: "438 Yuan",
          shuttleTransfer: "无",
          shuttleTransferEn: "No",
          distance: "离展馆1.9公里，周边方便",
          distanceEn:
            "1.9 km away from the exhibition hall, convenient surroundings",
        },
        {
          key: "8",
          name: "万信周浦万达店",
          nameEn: "Wanxin Zhoupu Wanda store",
          star: 4,
          address: "浦东新区周康路169号",
          addressEn: "169 Zhoukang Road, Pudong New Area",
          place: "398 元",
          placeEn: "398 Yuan",
          shuttleTransfer: "免费班车",
          shuttleTransferEn: "Free shuttle",
          distance: "18号地铁口，约20分钟，周边万达广场",
          distanceEn: "Metro Exit 18, about 20 minutes, around Wanda Plaza",
        },
        {
          key: "9",
          name: "锦江之星浦三路店",
          nameEn: "Jinjiang Star Pu SAN Road store",
          star: "连锁",
          starEn: "linkage",
          address: "浦东新区浦三路208号",
          addressEn: "208 Pu SAN Road, Pudong New Area",
          place: "388 元",
          placeEn: "388 Yuan",
          shuttleTransfer: "免费班车",
          shuttleTransferEn: "Free shuttle",
          distance: "距展馆6公里，约15分钟车程。周边方便",
          distanceEn:
            "6 km from the exhibition hall, about 15 minutes by car. Convenient surroundings",
        },
        {
          key: "10",
          name: "薪米国际酒店(原柏曼)",
          nameEn: "Cimi International Hotel (formerly Berman)",
          star: 4,
          address: "浦东新区高科东路1832号",
          addressEn: "No. 1832, East Gaoke Road, Pudong New Area",
          place: "318 元",
          placeEn: "318 Yuan",
          shuttleTransfer: "免费班车",
          shuttleTransferEn: "Free shuttle",
          distance: "2号线地铁口，车程20分钟。周边吃饭方便",
          distanceEn:
            "Line 2 subway exit, 20 minutes by car. Easy to eat around",
        },
        {
          key: "11",
          name: "富颐国际大酒店",
          nameEn: "The Rich International Hotel",
          star: 4,
          address: "周浦镇年家浜路6号",
          addressEn: "No. 6, Nian Jiabang Road, Zhoupu Town",
          place: "318 元",
          placeEn: "318 Yuan",
          shuttleTransfer: "免费班车",
          shuttleTransferEn: "Free shuttle",
          distance: "距展馆14公里，车程20分钟，周边大型商场",
          distanceEn:
            "14 km away from the exhibition hall, 20 minutes by car, surrounded by large shopping malls",
        },
        {
          key: "12",
          name: "锦江品尚川沙地铁站店",
          nameEn: "Jinjiang Pinshang Chuansha subway Station store",
          star: "连锁",
          starEn: "linkage",
          address: "川沙镇翔川路525弄9号",
          addressEn: "Chuansha Town Xiangchuan Road 525 lane 9",
          place: "298 元",
          placeEn: "298 Yuan",
          shuttleTransfer: "免费班车",
          shuttleTransferEn: "Free shuttle",
          distance: "2号线地铁口，车程20分钟，周边大型商场",
          distanceEn:
            "Line 2 subway exit, 20 minutes by car, surrounded by large shopping malls",
        },
        {
          key: "13",
          name: "博漾精品酒店",
          nameEn: "Boyang Boutique Hotel",
          star: 3,
          address: "浦东新区拯安路67-69号",
          addressEn: "No.67-69 Zhengan Road, Pudong New Area",
          place: "278 元",
          placeEn: "278 Yuan",
          shuttleTransfer: "无",
          shuttleTransferEn: "No",
          distance: "房间面积大，酒店可大型用餐歡，车程20分钟",
          distanceEn:
            "The room area is large, the hotel can have a large dining party, 20 minutes by car",
        },
      ],
      columns: [
        {
          title: this.$t("h.tran.hotelColunm1"),
          dataIndex: this.$language === "ZH" ? "name" : "nameEn",
          key: "name",
          align: "center",
        },
        {
          title: this.$t("h.tran.hotelColunm2"),
          align: "center",
          scopedSlots: { customRender: "star" },
        },
        {
          title: this.$t("h.tran.hotelColunm3"),
          dataIndex: this.$language === "ZH" ? "address" : "addressEn",
          key: "address",
          align: "center",
        },
        {
          title: this.$t("h.tran.hotelColunm4"),
          dataIndex: "price",
          key: "price",
          align: "center",
        },
        {
          title: this.$t("h.tran.hotelColunm5"),
          dataIndex: "shuttle",
          key: "shuttle",
          align: "center",
          scopedSlots: { customRender: "shuttle" },
        },
        {
          title: this.$t("h.tran.hotelColunm6"),
          dataIndex: this.$language === "ZH" ? "shuttleDesc" : "shuttleDescEn",
          key: "distance",
          align: "center",
        },
      ],
      value:
        this.$language === "ZH" ? "中国大陆地区品牌" : "China mainland brand",
      value1:
        this.$language === "ZH"
          ? "忑艺会展服务（上海）有限公司"
          : "Peri Exhibition Service (Shanghai) Co., LTD",
      value2: this.$language === "ZH" ? "Ms. Wang Chen" : "",
      value3:
        this.$language === "ZH"
          ? "电话：021 - 6420 0902 - 8025"
          : "Tel: 021-6420 0902-8025",
      value4:
        this.$language === "ZH"
          ? "电邮：shirley@grandevents.com.cn"
          : "Email: shirley@grandevents.com.cn",
      value5:
        this.$language === "ZH"
          ? "手机号：152 0213 1500"
          : "Phone number: 152 0213 1500",
      trafficTitle: "", //交通标题
      trafficSubTitle: "", //交通子标题
      hotelImage: "", //住宿顶部图片
      trafficData: [], //交通方式
      hotelData: [], //住宿酒店
      linkageInfo: [],
    };
  },
  created() {
    this.initConfig();
  },
  methods: {
    initConfig() {
      let titleCode =
        this.$language === "ZH" ? "TRAFFIC_TITLE" : "TRAFFIC_TITLE_EN";
      let subtitleCode =
        this.$language === "ZH" ? "TRAFFIC_SUBTITLE" : "TRAFFIC_SUBTITLE_EN";
      let imageCode =
        this.$language === "ZH" ? "HOTEL_IMAGE" : "HOTEL_IMAGE_EN";
      this.$axios.get(codeConfig + titleCode).then((res) => {
        this.trafficTitle = res && res.data.success ? res.data.result : "";
      });
      this.$axios.get(codeConfig + subtitleCode).then((res) => {
        this.trafficSubTitle = res && res.data.success ? res.data.result : "";
      });
      this.$axios.get(codeConfig + imageCode).then((res) => {
        this.hotelImage = res && res.data.success ? res.data.result : "";
      });
      this.$axios.get(trafficOptions).then((res) => {
        res.data.forEach((item) => {
          item.more = false;
        });
        this.trafficData = res.data ? res.data : [];
      });
      this.$axios.get(hotelTable).then((res) => {
        this.hotelData = res.data ? res.data : [];
      });
      this.$axios.get(linkage + "4").then((res) => {
        this.linkageInfo = res && res.data.success ? res.data.result : [];
      });
    },
    tabChange(index) {
      this.tabData.forEach((item, i) => {
        if (index == i) {
          item.select = true;
        } else {
          item.select = false;
        }
      });
      this.tabIndex = index;
    },
    itemClick(index) {
      this.trafficData[index].more = !this.trafficData[index].more;
    },
  },
};
</script>

<style scoped lang="scss">
.typeTitle {
  font-family: SourceHanSansCN-Medium;
  font-size: 14px;
  line-height: 35px;
  font-weight: bold;
  cursor: pointer;
  color: #131313;
}

.typeTitle {
  font-family: SourceHanSansCN-Medium;
  font-size: 14px;
  line-height: 35px;
  font-weight: bold;
  cursor: pointer;
}

.typeTitle:hover {
  color: #d7000f;
}

/* 富文本内容样式 - 支持后台设置的图片居中 */
::v-deep .rich-content img {
  max-width: 100%;
  height: auto;
}

::v-deep .rich-content p[style*="text-align: center"],
::v-deep .rich-content p[style*="text-align:center"],
::v-deep .rich-content div[style*="text-align: center"],
::v-deep .rich-content div[style*="text-align:center"] {
  text-align: center !important;
}

::v-deep .rich-content img[style*="display: block"],
::v-deep .rich-content img[style*="display:block"] {
  display: block !important;
}

::v-deep .rich-content img[style*="margin: 0 auto"],
::v-deep .rich-content img[style*="margin:0 auto"],
::v-deep .rich-content img[style*="margin: 0px auto"] {
  margin-left: auto !important;
  margin-right: auto !important;
}

::v-deep .rich-content img[style*="text-align: center"],
::v-deep .rich-content img[style*="text-align:center"] {
  display: block !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

::v-deep .rich-content img[align="middle"],
::v-deep .rich-content img[align="center"] {
  display: block !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

::v-deep .rich-content img.align-center,
::v-deep .rich-content img.image-center,
::v-deep .rich-content img.center {
  display: block !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

::v-deep .rich-content p[align="center"],
::v-deep .rich-content div[align="center"] {
  text-align: center !important;
}
</style>
